// extracted by mini-css-extract-plugin
module.exports = {"dropdown__menu":"_bQ","dropdown":"_bR","dropdown__trigger":"_bS","dropdown__icon":"_bT"};